import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vendora_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // don't kill the session on every 401 — only if we're authenticated
      const path = err.config?.url || "";
      if (!path.includes("/auth/login") && !path.includes("/auth/register")) {
        // optional: localStorage.removeItem("vendora_token");
      }
    }
    return Promise.reject(err);
  }
);
